import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _RawMaterialRequestDocument } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";

interface Props {

    idRawMaterialRequest: any
}

export const RawMaterialRequestDocument = ({ idRawMaterialRequest }: Props) => {

    const RawMaterialRequestDocument = useDataBean(_RawMaterialRequestDocument);
    const single = Singleton.getInstance();
    const [modaldoc, setModaldoc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [lista, setLista] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Ver Documento de Traslado", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        getLista();
    }, [idRawMaterialRequest])

    const getLista = () => {

        RawMaterialRequestDocument.instance.getRawMaterialRequestDocumentCatalog(idRawMaterialRequest).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        RawMaterialRequestDocument.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        RawMaterialRequestDocument.deleteItemVoid(RawMaterialRequestDocument.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        RawMaterialRequestDocument.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDRawMaterialRequestDocument', visible: true },
        { title: 'Documento', property: 'DocumentName', visible: true },
        { title: 'Fecha', property: 'DocumentDate', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },

    ]


    const listaBotones = () => {
        const botones = [

            { titulo: 'Ver Documento de Traslado', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const verDocumentos = () => {

        if (RawMaterialRequestDocument.bean.IDDocument && RawMaterialRequestDocument.bean.DocumentDate) {
            _documentos.instance.getPdfAccountantDocument(RawMaterialRequestDocument.bean.IDDocument, RawMaterialRequestDocument.bean.Mnemonic, RawMaterialRequestDocument.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setModaldoc({ ...modaldoc, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }

    return (
        <BasicPage titulo="Consultar Documentos de Traslado de Materia Prima">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={RawMaterialRequestDocument.setBean} listButtons={listaBotones()}></BasicTable>

                    <Modal modal={modalC} updateModal={setModalC} eventModal={verDocumentos}>
                        <>
                            <DocumentViewer list={docs} IDDocument={RawMaterialRequestDocument.bean.IDDocument} Since={RawMaterialRequestDocument.bean.DocumentDate} />
                        </>
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}